import { render, staticRenderFns } from "./FlujoParosTurno.vue?vue&type=template&id=5e70e3e7&scoped=true&"
import script from "./FlujoParosTurno.vue?vue&type=script&lang=js&"
export * from "./FlujoParosTurno.vue?vue&type=script&lang=js&"
import style0 from "./FlujoParosTurno.vue?vue&type=style&index=0&id=5e70e3e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e70e3e7",
  null
  
)

export default component.exports